import { useEffect } from "react";
import { IMatchReportsDetail, MatchReportsDetail } from "@sky-it-livedata/livedata-sports-design-system";
import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { MatchReportsDetailsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<MatchReportsDetailsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<MatchReportsDetailsQuery>): IMatchReportsDetail => {
  return transformer(props);
}


const matchReportsDetailWidget = ({props, ...rest}:WidgetContext<IMatchReportsDetail>) => {
    log({ props, ...rest });

    const SCROLL_OFFSET = 140;

    const intCmpEventHandler = useIntcmp();

    useEffect(() => {
        if (!isEmptyObject(props) && location.hash) {
          const el = document.querySelector(location.hash);
          if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
            window.scrollTo({ top });
          }
        }
      }, [props]);

    return (
        <div onClick={intCmpEventHandler}>
            <MatchReportsDetail {...props} />
        </div>
    );
}

export default matchReportsDetailWidget;